<template>
  <div v-loading="loading">
    <div class="flex-between">
      <div class="title">题目信息</div>
    </div>
    <el-card shadow="hover">
      <div slot="header">
        <span class="brand-color">基本信息</span>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">题目编号：</span>
          <span>{{ basicInfo.id }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">出题时间：</span>
          <span>{{ basicInfo.submit_at }}</span>
        </div>
      </div>
      <div class="flex">
        <div class="flex-item">
          <span class="flex-label">关联技能栈：</span>
          <span>{{ basicInfo.skill_name }}</span>
        </div>
        <div class="flex-item">
          <span class="flex-label">状态：</span>
          <el-tag v-if="basicInfo.status === 1" type="warning"
            >已提交待审核</el-tag
          >
          <el-tag v-if="basicInfo.status === 2">通过入库</el-tag>
          <el-tag v-if="basicInfo.status === 3" type="danger"
            >质检不通过</el-tag
          >
          <el-tag v-if="basicInfo.status === 4" type="danger">题目下架</el-tag>
          <el-tag v-if="basicInfo.status === 6">审核通过待质检</el-tag>
          <el-tag v-if="basicInfo.status === 7" type="danger"
            >审核不通过</el-tag
          >
          <el-tag v-if="basicInfo.status === 9">质检通过待终审</el-tag>
          <el-tag v-if="basicInfo.status === 10" type="danger">题目作废</el-tag>
          <el-tag v-if="basicInfo.status === 11" type="danger">终审驳回</el-tag>
        </div>
      </div>
      <div v-if="$route.query.type == 1">
        <div class="flex">
          <div class="flex-item">
            <span class="flex-label">审核时间：</span>
            <span>{{ basicInfo.verify_at }}</span>
          </div>
          <div class="flex-item">
            <span class="flex-label">审核次数：</span>
            <span>{{ basicInfo.verify_count }}</span>
          </div>
        </div>
      </div>
      <div v-if="$route.query.type == 2">
        <div class="flex">
          <div class="flex-item">
            <span class="flex-label">质检时间：</span>
            <span>{{ basicInfo.verify_at }}</span>
          </div>
          <div class="flex-item">
            <span class="flex-label">题目分数：</span>
            <span>{{ basicInfo.profession_level }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-item">
            <span class="flex-label">质检次数：</span>
            <span>{{ basicInfo.verify_count }}</span>
          </div>
        </div>
      </div>
    </el-card>

    <el-card shadow="hover">
      <div slot="header" class="flex-between">
        <span class="brand-color">题目内容</span>
      </div>
      <el-form
        class="mt-12"
        label-width="140px"
        :model="topicInfo"
        ref="topicInfo"
        :hide-required-asterisk="disabled"
      >
        <el-form-item
          label="题目类别："
          prop="question_type"
          :show-message="false"
        >
          <el-radio-group
            v-model="topicInfo.question_type"
            size="mini"
            :disabled="disabled"
          >
            <el-radio
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="难度等级：" prop="level" :show-message="false">
          <el-radio-group
            v-model="topicInfo.level"
            size="medium"
            :disabled="disabled"
          >
            <el-radio-button :label="1">简单</el-radio-button>
            <el-radio-button :label="2">普通</el-radio-button>
            <el-radio-button :label="3">困难</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="所属知识点："
          prop="knowledge_ids"
          :show-message="false"
        >
          <div v-for="(item, index) in selectKnowledgeArr" :key="index">
            <el-tag size="medium">{{ item.name }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="建议最长答题时间：" prop="time_max">
          <el-input-number
            v-model="topicInfo.time_max"
            label="描述文字"
            size="small"
            :disabled="disabled"
            :min="1"
          ></el-input-number>
          <span style="margin-left:10px;margin-right:10px;"> 单位 / 秒</span>
          <el-popover
            placement="top-start"
            width="500"
            title="提示"
            trigger="hover"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
          >
            <p class="popover-title">
              用户作答最长不超过的答题时长，超出时长未作答时将自动判错。请根据题目实际情况设置，一般情况下
            </p>
            <ul class="popover-list">
              <li class="popover-item">简单题目60秒</li>
              <li class="popover-item">普通题目90秒</li>
              <li class="popover-item">困难题目120秒</li>
            </ul>

            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </el-form-item>
        <el-form-item
          label="题目来源："
          prop="source_type"
          :show-message="false"
        >
          <el-radio-group v-model="topicInfo.source_type" :disabled="disabled">
            <el-radio
              v-for="(item, index) in sourceList"
              :key="index"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="查看方式：">
          <el-checkbox-group v-model="topicInfo.language" disabled>
            <el-checkbox label="zh-cn" checked disabled>中文</el-checkbox>
            <el-checkbox label="en">英文</el-checkbox>
            <el-checkbox label="fr">法文</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="language-container">
          <div class="language-box">
            <div class="language-title">中文</div>
            <el-form-item label="题干：" prop="stem" :show-message="false">
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.stem"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
            <el-form-item
              v-for="(option, index) in topicInfo.options"
              :key="index"
              :label="`选项 ${index + 1}：`"
              :prop="`options[${index}].content`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
            >
              <el-radio
                v-model="topicInfo.correctIndex"
                :label="index"
                :disabled="disabled"
                >正确答案</el-radio
              >
              <div class="topic-option">
                <div class="item-float-delete">
                  <el-link
                    v-if="!disabled"
                    icon="el-icon-delete"
                    :underline="false"
                    type="danger"
                    @click="deleteOption(index)"
                  ></el-link>
                </div>
                <Markdown
                  :value.sync="option.content"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  :defaultOpen="disabled ? 'preview' : 'edit'"
                  :disabled="disabled"
                  :option="!disabled ? 'assign_topic' : 'readmodel'"
                  class="min-w-400 min-h-200"
                ></Markdown>
              </div>
            </el-form-item>
            <el-form-item label="解析：" prop="analysis" :show-message="false">
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.analysis"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
          </div>
          <div class="language-box" v-if="topicInfo.language.includes('en')">
            <div class="language-title">英文</div>
            <el-form-item
              prop="en_stem"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.en_stem"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
            <el-form-item
              v-for="(option, index) in topicInfo.options"
              :key="index"
              :prop="`options[${index}].content`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
              label-width="10px"
            >
              <div style="height:40px"></div>
              <div class="topic-option">
                <Markdown
                  :value.sync="option.en_content"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  class="min-w-400 min-h-200"
                  :defaultOpen="disabled ? 'preview' : 'edit'"
                  :disabled="disabled"
                  :option="!disabled ? 'assign_topic' : 'readmodel'"
                ></Markdown>
              </div>
            </el-form-item>
            <div style="height:72px" v-show="!disabled"></div>
            <el-form-item
              prop="en_analysis"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.en_analysis"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
          </div>
          <div class="language-box" v-if="topicInfo.language.includes('fr')">
            <div class="language-title">法文</div>
            <el-form-item
              prop="fr_stem"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.fr_stem"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
            <el-form-item
              v-for="(option, index) in topicInfo.options"
              :key="index"
              :prop="`options[${index}].content`"
              :rules="{ required: true, trigger: 'blur' }"
              :show-message="false"
              label-width="10px"
            >
              <div style="height:40px"></div>
              <div class="topic-option">
                <Markdown
                  :value.sync="option.fr_content"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  class="min-w-400 min-h-200"
                  :defaultOpen="disabled ? 'preview' : 'edit'"
                  :disabled="disabled"
                  :option="!disabled ? 'assign_topic' : 'readmodel'"
                ></Markdown>
              </div>
            </el-form-item>
            <div style="height:72px" v-show="!disabled"></div>
            <el-form-item
              prop="fr_analysis"
              :show-message="false"
              label-width="10px"
            >
              <Markdown
                class="w-90pc min-h-200 min-w-400"
                :value.sync="topicInfo.fr_analysis"
                space="_for_kungfu_sub_project"
                folder="fuwu"
                :defaultOpen="disabled ? 'preview' : 'edit'"
                :disabled="disabled"
                :option="!disabled ? 'assign_topic' : 'readmodel'"
              ></Markdown>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </el-card>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapState } from "vuex";
import skillService from "@/global/service/skill";
import Markdown from "@/components/Markdown";
export default {
  components: {
    Markdown
  },
  data() {
    return {
      show: false,
      step: "check",
      showInfo: {},
      submitLoading: false,
      loading: true,
      disabled: true,
      dialogLoading: false,
      basicInfo: {
        id: null,
        unit_price: "",
        skill_id: null,
        skill_name: "",
        level: null,
        knowledge_ids: [],
        knowledges: [],
        status: null,
        status_label: ""
      },
      sourceList: [
        { value: 1, label: "原创" },
        { value: 2, label: "网络" },
        { value: 3, label: "翻译" },
        { value: 4, label: "购买" },
        { value: 5, label: "改编" },
        { value: 6, label: "其他" }
      ],
      typeList: [
        { value: 4, label: "场景" },
        { value: 2, label: "概念" },
        { value: 3, label: "代码" },
        { value: 1, label: "其他" }
      ],
      topicInfo: {
        level: null,
        knowledge_ids: [],
        stem: "",
        analysis: "",
        options: [],
        time_max: 60,
        correctIndex: 0,
        source_type: null,
        question_type: null,
        language: []
      },
      selectVisible: false,
      filterText: "",
      tree: [
        {
          text: "",
          children: []
        }
      ],
      formFirstInit: true,
      formChange: false,
      knowledgeChange: false,
      selectKnowledgeArr: []
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const id = this.$route.params.id;
      skillService
        .skillQuestionReviewTaskQuestionDetail(id)
        .then(res => {
          this.basicInfo.submit_at = res.submit_at;
          this.basicInfo.id = res.id;
          this.basicInfo.profession_level = res.profession_level;
          this.basicInfo.skill_id = res.stack.id;
          this.basicInfo.skill_name = res.stack.name;
          this.basicInfo.status = res.status;
          this.basicInfo.verify_count = this.$route.query.verify_count;
          this.basicInfo.verify_at = this.$route.query.verify_at;
          this.basicInfo.status_label = res.status_label;
          this.topicInfo.level = res.level;
          const knowledge_ids = res.knowledge_points.map(
            point => point.knowledge_point_id
          );
          this.topicInfo.time_max = res.time_max;
          this.topicInfo.source_type = res.source_type;
          this.topicInfo.question_type = res.question_type;
          this.topicInfo.language = res.languages;
          this.topicInfo.knowledge_ids = knowledge_ids;
          this.topicInfo.stem = res.translator["zh-cn"].stem;
          this.topicInfo.en_stem = res.translator["en"]
            ? res.translator["en"].stem
            : "";
          this.topicInfo.fr_stem = res.translator["fr"]
            ? res.translator["fr"].stem
            : "";
          this.topicInfo.analysis = res.translator["zh-cn"].analysis;
          this.topicInfo.en_analysis = res.translator["en"]
            ? res.translator["en"].analysis
            : "";
          this.topicInfo.fr_analysis = res.translator["fr"]
            ? res.translator["fr"].analysis
            : "";
          res.options.forEach((data, index) => {
            if (data.correct) this.topicInfo.correctIndex = index;
            this.topicInfo.options[index] = {
              id: data.id,
              content: data.translator["zh-cn"].option,
              en_content: data.translator["en"]
                ? data.translator["en"].option
                : "",
              fr_content: data.translator["fr"]
                ? data.translator["fr"].option
                : ""
            };
          });
          return {
            id: res.stack.id,
            ids: knowledge_ids
          };
        })
        .then(obj => {
          skillService
            .skillKnowledge(obj.id)
            .then(res => {
              this.treeChildren = res;
              this.getKnowledgeArr(obj.ids, this.treeChildren);
            })
            .finally(() => {
              this.loading = false;
            });
        });
    },
    getKnowledgeArr(ids = [], arr, result = [], parentName) {
      arr.forEach(item => {
        let name = parentName
          ? `${parentName} => ${item.text}`
          : `${this.basicInfo.skill_name} => ${item.text}`;
        if (ids.includes(item.id)) {
          result.push({
            id: item.id,
            name
          });
        }
        if (item.children.length) {
          this.getKnowledgeArr(ids, item.children, result, name);
        }
      });
      this.selectKnowledgeArr = result;
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  margin-bottom: 30px;
  overflow-x: scroll;
}
.flex {
  display: flex;
  margin-bottom: 12px;
  font-size: 14px;
  .flex-item {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .flex-label {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
}
.topic-option {
  position: relative;
  width: 90%;
  .item-float-delete {
    z-index: 1501;
    position: absolute;
    bottom: 10px;
    right: 12px;
    height: 0;
    overflow: hidden;
    .el-link {
      font-size: 16px;
    }
  }
  &:hover .item-float-delete {
    height: 28px;
  }
}
/deep/.el-dialog__body {
  padding-bottom: 0px !important;
}
.dialog-tree-container {
  padding: 0 20px;
  max-height: 340px;
  overflow: scroll;
}
.option-add-btn {
  margin-left: 120px;
  margin-bottom: 36px;
}

.language-container {
  display: flex;
}
.language-box {
  .language-title {
    text-align: center;
    margin-bottom: 20px;
  }
}
</style>
